import React, {useContext, useMemo, useState,} from 'react'
import {TabNavigation} from '../../Shared/components/TabNavigation'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {PiUserCirclePlusLight, PiUserFocusLight, PiUsersThreeLight} from "react-icons/pi";
import useTranslate from "../../../modules/local/useTranslate";
import {getId} from "../../../apis/model/base";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {useRouterSearchParam} from "modules/navigation/useOnLocationChange";
import {branch, compose, fromRenderProps, nest, pure, renderNothing} from "recompose";
import WorkspaceContext from "../WorkspaceContext";
import UseState from "../../../components/UseState";
import Members from "../../MemberSetting/Members.lazy";
import {GoverningOrganizationList} from "../Host/WorkspaceGoverningOrganizations";
import WaitingAcceptMembers from "../../MemberSetting/WaitingAcceptMembers.lazy";
import InviteManager from "../../Organization/Settings/InviteManager";
import {useMemberForm} from "../../MemberSetting/useMemberForm";
import {useOrgTypeLabel} from "../../../modules/local/useOrgTypeLabels";


const WorkspaceMembersList = compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, action, setAction, children}) => {

            return (
                <UseState initialValue={{type: undefined, value: undefined}}>
                    {([action, setAction]) => (
                        <Members
                            {...{action, setAction}}
                            item={container}>
                        </Members>
                    )}
                </UseState>
            )
        },
        GoverningOrganizationList
    )
)

const WorkspaceMembersWaitingList = compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, children}) => (
            <WaitingAcceptMembers
                item={container}>
            </WaitingAcceptMembers>
        ),
        GoverningOrganizationList
    )
)

const WorkspaceMembersInvites = compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, children}) => (
            <InviteManager
                item={container}>
            </InviteManager>
        ),
        GoverningOrganizationList
    )
)

const WorkspaceOrganizationMemberDetail = ({}) => {
    const t = useTranslate();
    const orgMemberDetailTab = useRouteSearchParam("org-member-tab") || "members"
    const [activeTab, setActiveTab] = useState(orgMemberDetailTab);
    const {isSm, isLg} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext)

    const memberLabel = useOrgTypeLabel(organization?.org_type, 'member', organization?.label_privacy)

    const orgMemberTabs = [
        {key: 'members', name: memberLabel || 'members', icon: <PiUsersThreeLight size={18}/>},
        {key: 'registers', name: 'registers', icon: <PiUserFocusLight size={18}/>},
        {key: 'invites', name: 'invites', icon: <PiUserCirclePlusLight size={18}/>},
    ]

    const {
        modal,
        handleAction,
        refreshKey
    } = useMemberForm({owner: organization})


    const {onChangeSearchParams} = useRouterSearchParam({})

    // Render nội dung cụ thể cho từng tab Cấp 2
    const renderOrgMemberContent = useMemo(() => {
            switch (activeTab) {
                case 'members':
                    return (
                        <div className="mt-3 flex flex-col gap-3">
                            {/*<h3 className="font-semibold text-sm text-gray-500 tracking-wide uppercase">*/}
                            {/*    {t("list of members")}*/}
                            {/*</h3>*/}
                            <WorkspaceMembersList/>
                        </div>
                    );
                case 'registers':
                    return (
                        <div className="mt-3 flex flex-col gap-3">
                            {/*<h3 className="font-semibold text-sm text-gray-500 tracking-wide uppercase">*/}
                            {/*    {t("registers")}*/}
                            {/*</h3>*/}
                            <WorkspaceMembersWaitingList/>
                        </div>
                    );
                case 'invites':
                    return (
                        <div className="mt-3 flex flex-col gap-3">
                            {/*<h3 className="font-semibold text-sm text-gray-500 tracking-wide uppercase">*/}
                            {/*    {t("invites")}*/}
                            {/*</h3>*/}
                            <WorkspaceMembersInvites/>
                        </div>
                    );

                default:
                    return null;
            }
        },
        [activeTab]);

    return (
        <div className="min-h-screen w-full">
            <div className="flex items-center gap-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t(memberLabel)}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <div className="mt-1 mr-4 text-sm text-color-300 tracking-wider">
                        {t('workspace member title description')}
                    </div>
                </div>
            </div>

            <TabNavigation
                tabs={orgMemberTabs}
                activeTab={activeTab}
                className="mt-3 border-color-50 stickyTop1"
                onTabChange={(value) => {
                    onChangeSearchParams({"org-member-tab": value})
                    setActiveTab(value)
                }}/>

            {renderOrgMemberContent}

            {modal}
        </div>
    );
};


export default WorkspaceOrganizationMemberDetail
